import DifferentialEquation from './DifferentialEquation';

const { min, max } = Math;

const clamp = (x, absmax) => max(-absmax, min(absmax, x));

/* d²Ψ/d²t = c² d²Ψ/dx² */
export default class WaveEquation extends DifferentialEquation {

	length = null;
	x = null;
	d = null;
	d2 = null;

	constructor(data) {
		super();
		this.length = data.length;
		this.x = data;
		this.d = new Float32Array(data.length);
		this.d2 = new Float32Array(data.length);
	}

	apply(dt, c) {
		const length = this.length;
		const x = this.x;
		const d = this.d;
		const d2 = this.d2;
		const dx = 1 / length;
		const dx2 = dx * dx;
		const c2 = c * c;
		/* d²Ψ/dt² = c² d²Ψ/dx² */
		for (let i = 1; i < length - 1; i++) {
			d2[i] = (x[i + 1] + x[i - 1] - 2 * x[i]) * c2 / dx2;
		}
		/* Δ dΨ/dt = Δt d²Ψ/dt² */
		for (let i = 1; i < length - 1; i++) {
			d[i] += d2[i] * dt;
		}
		/* Δ Ψ = dΨ/dt * Δt */
		for (let i = 1; i < length - 1; i++) {
			x[i] += clamp(d[i], 10) * dt;
		}
	}
}
